export enum ViewType {
    PREVIEW,
    ADD,
    EDIT,
}

// type BtnColorTypes = { [K in ButtonType]: { type: K, background: string, textColor: string } };